import type { QueryView } from '@krp/client-runtime'

/** Право, без которого окно «Обмен с AQSI» не открыть (вместе с `sales.read`): чтение команд кассе. */
export const EXCHANGE_CAPABILITY = 'operations.read'

/** Один запрос службы к кабинету AQSI по продаже и ответ на него — как их отдала служба (`aqsi.sale.exchanges`). */
export interface AqsiSaleExchange {
  id: string
  /** `sale` — запрос по продаже, `operation` — по номеру её операции у AQSI, `device` — команда той же кассы рядом по времени,
   * `foreign-webhook` — уведомление AQSI по операции, которой нет у продаж программы. */
  relation: string
  operationId: string | null
  /** `Purchase`, `Receipt`, `RefundPayment`, `RefundReceipt`, `ShiftOpen`, `ShiftClose`, `DeviceCheck`; неизвестный — как пришёл. */
  operationKind: string | null
  externalOperationId: string | null
  deviceId: number | null
  /** `submit` — команда, `cancel` — просьба снять с терминала, `read` — чтение состояния, `webhook` — уведомление AQSI. */
  command: string
  method: string
  path: string
  sentAt: string
  answeredAt: string
  durationMs: number
  requestBody: string
  requestLength: number
  /** `null` — ответа не было. */
  httpStatus: number | null
  responseBody: string | null
  responseLength: number | null
  failure: string | null
  note: string | null
  /** Операция, которую AQSI назвал в отказе («на устройстве выполняется другая операция»). */
  mentionedOperationId: string | null
}

export interface AqsiSaleExchangeList {
  saleId: string
  items: readonly AqsiSaleExchange[]
  complete: boolean
}

/** Строка тела для показа: строки с кассиром выделяются. */
export interface ExchangeLineVm {
  text: string
  cashier: boolean
}

export type ExchangeTone = 'ok' | 'warning' | 'danger'

export interface ExchangeItemVm {
  id: string
  /** «Чек: отправка», «Оплата картой: просьба снять с терминала». */
  titleText: string
  /** Почему строка у этой продажи (команда кассы рядом по времени, «не наше» уведомление); у запроса по самой продаже — `null`. */
  relationText: string | null
  /** Номера операции у AQSI и прочие факты строки: «Операция AQSI: …», «AQSI назвал операцию: …». */
  facts: readonly string[]
  requestTitle: string
  responseTitle: string
  sentText: string
  durationText: string
  /** «HTTP 500 — ошибка кабинета», «Ответа нет». Вид — значок и слово, не только цвет. */
  statusText: string
  tone: ExchangeTone
  requestText: string
  requestLines: readonly ExchangeLineVm[]
  /** Что в запросе о кассире: у чека — имя или «кассир не передан»; у операций с картой — `null`. */
  cashierText: string | null
  requestCutText: string | null
  responseText: string | null
  responseLines: readonly ExchangeLineVm[]
  responseCutText: string | null
  failureText: string | null
  /** Всё о запросе одним текстом — для кнопки «Скопировать» и передачи администратору. */
  reportText: string
}

export interface SaleExchangeVm {
  resourceId: string
  saleId: string
  query: QueryView
  items: readonly ExchangeItemVm[]
  /** Служба отдала не все запросы (предел). */
  incompleteText: string | null
  /** Весь журнал одним текстом. */
  reportText: string
}

export interface SaleExchangeActions {
  reload: () => void
  close: () => void
}
